import React from 'react';
import PropTypes from 'prop-types';

import StyledHeading from './Styles';

const propTypes = {
  testId: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  variant: PropTypes.oneOf(['regular', 'light', 'bold'])
};

const defaultProps = {
  testId: undefined,
  className: undefined,
  children: undefined,
  variant: 'regular'
};

const Heading = ({ testId, className, children, variant }) => (
  <StyledHeading data-testid={testId} className={className} variant={variant}>
    {children}
  </StyledHeading>
);

Heading.propTypes = propTypes;
Heading.defaultProps = defaultProps;

export default Heading;
